import { combineReducers, AnyAction } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducer from './auth';
import reducerConsist from './typemarkReducer';
import companyReducer from './companyReducer';
import * as actionTypes from '../actions/actionTypes';
import LanguageDetector from 'i18next-redux-languagedetector';
import menuReducer from './menuReducer';
import classificationReducer from './classificationReducer';
import cultureReducer from './cultureReducer';
import contractReducer from './contractReducer';
import dbItemsReducer from './dbItemsReducer';
import createNamedWrapperReducer from './wrappers/createNamedWrapperReducer';
import typeMarkReducer from './typemarkReducer';
import leftPanelWithDetailReducer from './leftPanelWithDetailReducer';
import typeMarkTemplateReducer from './typemarkTemaplateReducer';
import notificationsReducer from './notificationsReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['access_token', 'refresh_token', 'loading', 'error'],
};

const appReducer = combineReducers({
  auth: persistReducer(authPersistConfig, reducer),
  company: companyReducer,
  consist: reducerConsist,
  i18next: LanguageDetector,
  menu: menuReducer,
  classification: classificationReducer,
  culture: cultureReducer,
  contract: contractReducer,
  typeMark: typeMarkReducer,
  typeMarkTemplate: typeMarkTemplateReducer,
  notifications: notificationsReducer,
  solution: createNamedWrapperReducer(dbItemsReducer, 'SOLUTION'),
  product: createNamedWrapperReducer(dbItemsReducer, 'PRODUCT'),
  propertyDefinition: createNamedWrapperReducer(dbItemsReducer, 'PROPERTY_DEFINITION'),
  professionBond: createNamedWrapperReducer(dbItemsReducer, 'PROFESSION_BOND'),
  propertySet: createNamedWrapperReducer(dbItemsReducer, 'PROPERTY_SET'),
  technicalReportItem: createNamedWrapperReducer(dbItemsReducer, 'TECHNICAL_REPORT_ITEM'),
  technicalReportItemSet: createNamedWrapperReducer(dbItemsReducer, 'TECHNICAL_REPORT_ITEM_SET'),
  biblio: createNamedWrapperReducer(dbItemsReducer, 'BIBLIO'),
  unit: createNamedWrapperReducer(dbItemsReducer, 'UNIT'),
  buildingObject: createNamedWrapperReducer(leftPanelWithDetailReducer, 'BUILDING_OBJECT'),
  contractListing: createNamedWrapperReducer(leftPanelWithDetailReducer, 'CONTRACT_LISTING'),
  model: createNamedWrapperReducer(leftPanelWithDetailReducer, 'MODEL'),
  phase: createNamedWrapperReducer(leftPanelWithDetailReducer, 'PHASE'),
  print: createNamedWrapperReducer(leftPanelWithDetailReducer, 'PRINT'),
});

export type AppState = ReturnType<typeof appReducer>;

const mainReducer = (state: AppState | undefined, action: AnyAction): AppState => {
  if (action.type === actionTypes.AUTH_LOGOUT) {
    return appReducer(undefined, action);
  }
  if (action.type === actionTypes.CHANGE_CURRENT_COMPANY) {
    return appReducer({ auth: state!.auth, menu: state!.menu } as AppState, action);
  }

  return appReducer(state, action);
};

export default mainReducer;
